/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ConditionType = "contains" | "endsWith" | "equals" | "greaterThan" | "greaterThanOrEqual" | "inRange" | "lessThan" | "lessThanOrEqual" | "notContains" | "notEqual" | "startsWith" | "%future added value";
export type FilterType = "date" | "number" | "text" | "%future added value";
export type OperatorType = "AND" | "OR" | "%future added value";
export type Filter = {|
  name: string,
  filterType: FilterType,
  operator: OperatorType,
  denySelection?: ?boolean,
  conditions: $ReadOnlyArray<?Condition>,
|};
export type Condition = {|
  value: $ReadOnlyArray<?string>,
  type: ConditionType,
|};
export type GetBulletinDownloadPathQueryVariables = {|
  filters?: ?$ReadOnlyArray<?Filter>,
  companyId: string,
  propertyUnitId: string,
|};
export type GetBulletinDownloadPathQueryResponse = {|
  +Me: ?{|
    +Company: ?{|
      +HouseEntrance: ?{|
        +data: $ReadOnlyArray<?{|
          +id: string,
          +tableId: number,
          +download: ?{|
            +name: string,
            +path: string,
            +token: string,
          |},
        |}>
      |}
    |}
  |}
|};
export type GetBulletinDownloadPathQuery = {|
  variables: GetBulletinDownloadPathQueryVariables,
  response: GetBulletinDownloadPathQueryResponse,
|};
*/


/*
query GetBulletinDownloadPathQuery(
  $filters: [Filter]
  $companyId: ID!
  $propertyUnitId: ID!
) {
  Me {
    Company(id: $companyId) {
      HouseEntrance(id: $propertyUnitId) {
        data: bulletins(options: {filters: $filters}) {
          id
          tableId
          download {
            name
            path
            token
          }
        }
        id
      }
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "companyId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyUnitId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "companyId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "propertyUnitId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": "data",
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "filters"
        }
      ],
      "kind": "ObjectValue",
      "name": "options"
    }
  ],
  "concreteType": "Bulletin",
  "kind": "LinkedField",
  "name": "bulletins",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tableId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DownloadDetails",
      "kind": "LinkedField",
      "name": "download",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "token",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GetBulletinDownloadPathQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "HouseEntrance",
                "kind": "LinkedField",
                "name": "HouseEntrance",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "GetBulletinDownloadPathQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "HouseEntrance",
                "kind": "LinkedField",
                "name": "HouseEntrance",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "21abcf67dd767dd2c28e556e835647b9",
    "id": null,
    "metadata": {},
    "name": "GetBulletinDownloadPathQuery",
    "operationKind": "query",
    "text": "query GetBulletinDownloadPathQuery(\n  $filters: [Filter]\n  $companyId: ID!\n  $propertyUnitId: ID!\n) {\n  Me {\n    Company(id: $companyId) {\n      HouseEntrance(id: $propertyUnitId) {\n        data: bulletins(options: {filters: $filters}) {\n          id\n          tableId\n          download {\n            name\n            path\n            token\n          }\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b2929e8b7135d9169ca3a45c12788fdd';

module.exports = node;
